import { createFileRoute } from '@tanstack/react-router'
import { KbSearchView } from '@/features/kb/KbSearchView'

export const Route = createFileRoute('/kb/')({ component: KbSearchView })
